import { useEffect, useState } from 'react';
import { InputLabel, Select, FormHelperText, FormControl, MenuItem, SelectChangeEvent } from '@mui/material';
import { labelStyle, container, inputStyle, helperStyle } from './styles';
import { SelectCustomProps } from './types';

export default function CustomizedInputs({
  appId,
  name,
  label,
  helperText,
  isDirty: _isDirty,
  value: _value,
  setValue,
  items,
  placeholder,
  error,
  defaultValue,
  disabled
}: SelectCustomProps) {
  const [selected, setSelected] = useState('');

  useEffect(() => {
    if (defaultValue) {
      setSelected(defaultValue);
    }
  }, [defaultValue]);

  const fieldId = appId ?? `input-${name}`;

  return (
    <FormControl data-app-id={appId ? `${appId}-control` : undefined} sx={container} variant="outlined">
      <InputLabel
        data-app-id={appId ? `${appId}-label` : undefined}
        htmlFor={fieldId}
        shrink
        sx={{ ...labelStyle, position: 'static', transform: 'none', whiteSpace: 'break-spaces' }}
      >
        {label}
      </InputLabel>
      <>
        <Select
          data-app-id={appId ? `${appId}-input` : undefined}
          id={fieldId}
          value={selected}
          sx={inputStyle}
          placeholder="Select a value..."
          onChange={(event: SelectChangeEvent<typeof selected>) => {
            const {
              target: { value: v }
            } = event;
            setSelected(v);
            setValue(v);
          }}
          displayEmpty
          renderValue={(selected) => {
            if (selected === '') {
              return <em>{placeholder}</em>;
            }
            for (let i = 0; i < items.length; i++) {
              if (selected === items[i].value) {
                return items[i].label;
              }
            }
          }}
          inputProps={{
            'aria-label': label,
            ...(appId ? { 'data-app-id': `${appId}-input-element` } : {})
          }}
          disabled={!!disabled}
        >
          {placeholder && (
            <MenuItem disabled value="">
              <em>{placeholder}</em>
            </MenuItem>
          )}
          {items.map((item, index) => (
            <MenuItem value={item.value} key={index}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        {helperText && error && (
          <>
            <FormHelperText sx={helperStyle}>{helperText}</FormHelperText>
          </>
        )}
      </>
    </FormControl>
  );
}
